import http from '@http';
import apis from './apis';

const axios = http();

export default class SystemService {
    static getList(params) {
        return axios.post(apis.getList, params);
    }

    // 获取跳转小程序码
    static getQrcode(params) {
        return axios.post(apis.getQrcode, params);
    }

}
